module.exports = __webpack_public_path__ + "img/section5Logo1.f098e8ec.svg";